import { useEffect } from 'react';

import { useStoreContext } from 'features/store';

import {
  useEnableMinimalCartExperiment,
  useMinimalCartExperimentVariant,
} from 'experiments/use-enable-minimal-cart-experiment';
import { useExperiments } from 'state/experiments';
import { logger } from 'utils/logger';

const LOG_DELAY_MS = 100;
const logTimeoutId = { current: null as NodeJS.Timeout | null };
export const isMessageLogged = { current: false };

export const useMinimalCartUi = () => {
  const isMinimalCartUiEnabled = useEnableMinimalCartExperiment();
  const minimalCartExperimentVariant = useMinimalCartExperimentVariant();
  const { isLoading: isExperimentsLoading } = useExperiments();
  const { store } = useStoreContext();
  const posVendor = store.pos?.vendor?.toLowerCase();

  useEffect(() => {
    if (isMessageLogged.current) {
      return;
    }

    // Wait for deps (flag + store/vendor) to settle before logging to avoid false negatives
    if (!posVendor || isExperimentsLoading) {
      return;
    }

    if (logTimeoutId.current) {
      clearTimeout(logTimeoutId.current);
    }

    logTimeoutId.current = setTimeout(() => {
      logger.info({
        message: `Minimal cart UI ${isMinimalCartUiEnabled ? 'enabled' : 'disabled'}`,
        isMinimalCartUiEnabled,
        isExperimentsLoading,
        minimalCartExperimentVariant,
        posVendor,
        storeId: store?.number,
      });
      isMessageLogged.current = true;
    }, LOG_DELAY_MS);

    return () => {
      if (logTimeoutId.current) {
        clearTimeout(logTimeoutId.current);
      }
    };
  }, [
    isMinimalCartUiEnabled,
    isExperimentsLoading,
    minimalCartExperimentVariant,
    posVendor,
    store?.number,
  ]);

  return isMinimalCartUiEnabled;
};
